import { Box } from "@mui/material"
import { useParams } from "@tanstack/react-router"
import type { FC } from "react"
import React from "react"

import { CompanyStatus } from "@/graphql/codegen/graphql"
import { COMPANY_EDIT_ROUTE } from "@/screens/Companies/constants"
import CompanyFilesContainer from "@/screens/Companies/edit/components/info/containers/CompanyFilesContainer"
import CompanyInfoFormContainer from "@/screens/Companies/edit/components/info/containers/CompanyInfoFormContainer"
import useCompanyInfo from "@/screens/Companies/edit/components/info/hooks/useCompanyInfo"

const CompanyInfoContainer: FC = () => {
  const { companyId } = useParams({ from: COMPANY_EDIT_ROUTE })
  const { companyInfo } = useCompanyInfo({ companyId })
  return (
    <Box className='flex flex-col overflow-y-auto'>
      {companyInfo && <CompanyInfoFormContainer companyInfo={companyInfo} />}
      <CompanyFilesContainer isActiveCompany={companyInfo?.status === CompanyStatus.Active} companyId={companyId} />
    </Box>
  )
}

export default CompanyInfoContainer
